import type { I18nFn } from 'i18n/types/I18nFn';

export const SearchOrgRefinement = {
  AREAS_OF_FOCUS: 'areasOfFocus',
  LOCALE: 'locale',
  ORG_TYPE: 'orgType',
  RADIUS: 'radius',
} as const;

export const SEARCH_ORGS_REFINEMENT_NAMES = Object.values(SearchOrgRefinement);

export type SearchOrgsRefinementType =
  (typeof SearchOrgRefinement)[keyof typeof SearchOrgRefinement];

export function SEARCH_ORGS_REFINEMENT_LABELS(i18n: I18nFn) {
  return {
    [SearchOrgRefinement.AREAS_OF_FOCUS]: i18n('Cause Areas'),
    [SearchOrgRefinement.LOCALE]: i18n('Listing Language'),
    [SearchOrgRefinement.ORG_TYPE]: i18n('Org Type'),
    [SearchOrgRefinement.RADIUS]: i18n('Radius'),
  } as Record<SearchOrgsRefinementType, string>;
}
